<template>
    <treeselect
        v-model="selectedCategories"
        @select="addCategory"
        @deselect="removeCategory"
        multiple
        searchable
        clearOnSelect
        :clearable="false"
        :options="categoriesOptions"
        :disabled="isLoadingCategories || disableCategories"
        :placeholder="isLoadingCategories ? 'Loading...' : 'Select category'"
        :default-expand-level="1"
        disableFuzzyMatching
        flattenSearchResults
        disable-branch-nodes
    >
        <!-- DISABLE clearable 
         function : to clear all at once
         reason to disable : because every changes needs to go through select or deselect action 
    -->
        <template slot="value-label" slot-scope="{ node }">
            {{ node.label }}
        </template>
        <template slot="option-label" slot-scope="{ node }">
            <label v-if="node.isBranch" class="font-weight-bold parent">
                {{ node.label }}
            </label>
            <label v-else class="selection">
                {{ node.label }}
            </label>
        </template>
    </treeselect>
</template>
<script>
import Treeselect from "@riophae/vue-treeselect";

export default {
    components: {
        Treeselect
    },
    props: {
        disableCategories: {
            type: Boolean,
            default: false
        },
        originalSelected: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            value: null,
            isLoadingCategories: false,
            selectedCategories: [],
            categoriesOptions: [],
            categoriesRefs: {}
        };
    },
    mounted() {
        this.fetchCategories();
    },
    methods: {
        onChange(value) {
            console.log("onChange", value);
            this.$emit("input", value);
        },
        addCategory(item) {
            this.$emit("add-category", item);
        },
        removeCategory(item) {
            this.$emit("remove-category", item);
        },
        processSelectedIds() {
            // TBC REMOVE?
            let ids = [];
            let categories = this.originalSelected ?? [];
            for (let cat of categories) {
                // must go check CHILD LEVEL. TODO HERE
                let theCategory = this.categoriesOptions.find(
                    item => item.id === cat.category_id
                );

                if (theCategory) {
                    // include only if category exist
                }

                ids.push(cat.category_id);
                this.addCategory({
                    id: cat.category_id,
                    label: this.categoriesRefs[cat.category_id] || "--",
                    customLabel: this.categoriesRefs[cat.category_id] || "--"
                });
            }

            this.selectedCategories = ids;
        },
        getSelectedIds() {
            let ids = [];
            let categories = this.originalSelected ?? [];
            // REQUIRED : originalSelected contains category_id

            for (let cat of categories) {
                ids.push(cat.category_id);
                this.addCategory({
                    id: cat.category_id,
                    label: this.categoriesRefs[cat.category_id] || "--",
                    customLabel: this.categoriesRefs[cat.category_id] || "--"
                });
            }

            this.selectedCategories = ids;
        },
        async fetchCategories() {
            this.isLoadingCategories = true;

            const res = await this.$http.get(
                `${process.env.BARRAMUNDI}inventory/category-by-type`
            );

            let resources = res?.data?.response?.resources ?? [];
            let catRefs = {};
            let options = resources.map(r => {
                return {
                    id: r.id,
                    label: r.value,
                    customLabel: r.value,
                    children: r?.category?.map(c => {
                        catRefs[c.id] = c.name;
                        return {
                            id: c.id,
                            parentId: c.item_type_id,
                            parentClassId: c.item_class_id,
                            label: c.name,
                            customLabel: c.name
                        };
                    })
                };
            });

            this.categoriesRefs = catRefs;
            this.categoriesOptions = options;
            this.isLoadingCategories = false;

            if (this.originalSelected.length > 0) {
                // this.processSelectedIds();
                this.getSelectedIds();
            }
        }
    }
};
</script>
<style lang="scss" scoped>
::v-deep .vue-treeselect__multi-value-item {
    color: black;
    background: #f0f0f0;
    font-size: 1em;
    border-radius: 4px;
    border: 1px solid #cacaca;

    .vue-treeselect__icon.vue-treeselect__value-remove {
        color: gray;

        &:hover {
            color: black;
        }
    }
}

::v-deep .vue-treeselect__indent-level-1 .vue-treeselect__option {
    padding-left: 0;
}

label.parent {
    margin: 0;
}
label.selection {
    font-weight: normal !important;
    margin: 0;
}
</style>
